<cap-list-loader [listLoader]="listLoader">
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <tr>
          @if (showTagebuch) {
            <th>
              <cap-column-header [columnName]="'Tagebuchnummer'" [sortModel]="tableSortModel.columns.get('geschaeftsNummer')">
              </cap-column-header>
            </th>
          }
          <th>
            <cap-column-header
              [columnName]="'grundbuchmeldung.empfaenger.bezeichnung'"
              [sortModel]="tableSortModel.columns.get('empfaengerBezeichnung')">
            </cap-column-header>
          </th>
          <th>
            <cap-column-header [columnName]="'meldungsempfaenger.sedexid'" [sortModel]="tableSortModel.columns.get('empfaengerSedexId')">
            </cap-column-header>
          </th>
          <th>
            <cap-column-header [columnName]="'grundbuchmeldung.meldungsstatus'" [sortModel]="tableSortModel.columns.get('meldungsStatus')">
            </cap-column-header>
          </th>
          <th>
            <cap-column-header [columnName]="'grundbuchmeldung.datummeldung'" [sortModel]="tableSortModel.columns.get('datumMeldung')">
            </cap-column-header>
          </th>
          <th>
            <!-- actions -->
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of listLoader?.items; track item) {
          <tr>
            @if (showTagebuch) {
              <td>
                <cap-link
                  [params]="[item.gbGeschaeftId.id]"
                  [queryParams]="{ activeTabId: 'meldungsempfaenger' }"
                  [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
                  {{ item.geschaeftsnummer | formatGeschaeftsnummer }}
                </cap-link>
              </td>
            }
            <td>
              @if (item.viewEmpfaengerPossible) {
                <cap-link [params]="[item.id.id]" [target]="navTargets.NAV_ECH0134_MELDUNGSEMPFAENGER">
                  {{ item.empfaengerBezeichnung }}
                </cap-link>
              }
              @if (!item.viewEmpfaengerPossible) {
                {{ item.empfaengerBezeichnung }}
              }
            </td>
            <td>
              @if (item.viewEmpfaengerPossible) {
                <cap-link [params]="[item.id.id]" [target]="navTargets.NAV_ECH0134_MELDUNGSEMPFAENGER">
                  {{ item.empfaengerSedexId }}
                </cap-link>
              }
              @if (!item.viewEmpfaengerPossible) {
                {{ item.empfaengerSedexId }}
              }
            </td>
            <td>
              {{ translateMeldungsStatusEnum(item.meldungsStatus) }}
            </td>
            <td>
              {{ item.datumMeldung | datumZeit }}
            </td>
            <td class="text-end">
              @if (meldungErstellt(item)) {
                @if (item.statusResetPossible) {
                  <button
                    (click)="onReset(item, resetButton)"
                    [ngbTooltip]="'grundbuchmeldung.reset' | translate"
                    #resetButton
                    class="btn btn-dark btn-sm me-2"
                    placement="left"
                    type="button">
                    <i class="fas fa-reply-all"></i>
                  </button>
                }
                <button
                  (click)="onDownload(item, downloadButton)"
                  [ngbTooltip]="'grundbuchmeldung.download' | translate"
                  #downloadButton
                  class="btn btn-dark btn-sm"
                  placement="left"
                  type="button">
                  <i class="fas fa-download"></i>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</cap-list-loader>
